import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Href, Widgets } from "../../../../Constants/Constants";

const SplitDemo = () => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup>
      <Btn outline color="primary">{Widgets}</Btn>
      <Dropdown className="separated-btn" isOpen={open} toggle={() => setOpen(!open)} direction="down">
        <DropdownToggle color="primary">
          <i className="icofont icofont-arrow-down"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-content">
          <DropdownItem href={Href}>{"General"}</DropdownItem>
          <DropdownItem href={Href}>{"Chart"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default SplitDemo;
